import { IconButton, LinearProgress } from '@material-ui/core';
import ImageWrapper from 'components/ImageWrapper';
import ExtractOutlineIcon from 'images/icons/objects/clocks/clockArrowBackDarkGrayOutline.svg';
import PrintLabelProductOutlineIcon from 'images/icons/objects/printers/printerYellowOutline.svg';
import PrintLabelProductDisabledIcon from 'images/icons/objects/printers/printerLightGrayOutline.svg';
import DeleteProductOutlineIcon from 'images/icons/signals/removesAndDeletes/newTrash.svg';
import moment from 'moment/moment';
import { useHistory } from 'react-router-dom';
import ValidationLength from 'utils/utils';
import { ProductTable } from '../../styles';

function DesktopProductsTable({
  mainLoading,
  products,
  getId,
  handleDelete,
  setModalSettings,
  modalSettings,
  labelManagerHasAllPermissions
}) {
  const history = useHistory();

  const getValidityText = (p) => {
    const type = (p?.expirationType || '').toString().toUpperCase();
    const hasNewField =
      p?.expirationDuration !== undefined && p?.expirationDuration !== null;
    const dur = hasNewField ? Number(p.expirationDuration) : null;

    if (type === 'HOUR') {
      return dur > 0 ? `${dur} ${dur !== 1 ? 'horas' : 'hora'}` : '-';
    }

    if (type === 'DAY') {
      if (hasNewField) {
        return `${dur} ${dur === 1 ? 'dia' : 'dias'}`;
      }
    }

    if (p?.quantityValidDays !== undefined && p?.quantityValidDays !== null) {
      const legacy = Number(p.quantityValidDays);
      return `${legacy} ${legacy === 1 ? 'dia' : 'dias'}`;
    }

    return '-';
  };

  return (
    <ProductTable
      className="desktop"
      cellPadding="0"
      cellSpacing="0"
      border="0"
    >
      <thead>
        <tr className="headerTitle">
          <th className="imageColumn subtitle pr8 pl8">&nbsp;</th>

          <th className="descriptionColumn subtitle pr8 pl8">PRODUTO</th>

          <th className="unitColumn subtitle center pr8 pl8">UN.</th>

          <th className="categoryColumn subtitle pr8 pl8">CATEGORIA</th>

          <th className="conservationColumn subtitle pr8 pl8">
            ESTADO DE CONSERVAÇÃO
          </th>

          <th className="validityColumn subtitle left pr8 pl8">VALIDADE</th>

          <th className="maturityColumn subtitle center pr8 pl8">VENCIMENTO</th>

          <th className="iconsColumn subtitle left pr8 pl8" />
        </tr>
      </thead>

      <tbody>
        {mainLoading && (
          <tr>
            <th colSpan={8} className="m10 textAlignCenter">
              <LinearProgress
                style={{ height: '7px' }}
                id="loading"
                variant="query"
              />
            </th>
          </tr>
        )}

        {products?.length ? (
          products.map((product) => {
            const labelCountObj = [
              {
                type: 'expired',
                count: product?.expiredCount
              },
              {
                type: 'onDate',
                count: product?.onDateCount
              },
              {
                type: 'valid',
                count: product?.validCount
              }
            ];

            return (
              <>
                <tr className="lineBorder">
                  <td className="description dFlex alignCenter pt8 pr8 pb8 pl8">
                    <ImageWrapper
                      width="34px"
                      height="34px"
                      url={product?.image?.url}
                      borderType={product?.type}
                    />
                  </td>

                  <td className="description left pr8 pl8">
                    <span
                      className="cursorPointer lightBlue"
                      onClick={() => {
                        history.push(
                          `/etiquetas/catalogo/produtos/${getId}/${product?.id}`
                        );
                        setModalSettings(
                          modalSettings.map((modal) =>
                            modal.name === 'productDialog'
                              ? { ...modal, open: true }
                              : modal
                          )
                        );
                      }}
                    >
                      {ValidationLength(product?.description, 50)}
                    </span>
                  </td>

                  <td className="description center pr8 pl8">
                    {product?.consumptionUnitsPrimary?.abbreviation}
                  </td>

                  <td
                    style={{
                      borderLeft: 'solid 1px rgba(208, 211, 226, 1)'
                    }}
                    className="description left pr8 pl8"
                  >
                    {ValidationLength(
                      product?.categories?.description || '-',
                      25
                    )}
                  </td>

                  <td
                    style={{
                      borderLeft: 'solid 1px rgba(208, 211, 226, 1)'
                    }}
                    className="description left pr8 pl8"
                  >
                    {ValidationLength(
                      product?.conservation?.description || '-',
                      25
                    )}
                  </td>

                  <td
                    className={`description left pr8 pl8 ${product?.labelStatus?.toLowerCase()}`}
                    style={{
                      borderLeft: 'solid 1px rgba(208, 211, 226, 1)'
                    }}
                  >
                    <span>
                      {getValidityText(product)}
                    </span>
                  </td>

                  <td
                    className="description right pr8 pl8"
                    style={{
                      borderLeft: 'solid 1px #860891'
                    }}
                  >
                    <div className="labelCountContainer">
                      {labelCountObj?.map((label) => (
                        <div
                          key={label.type}
                          className={`labelCountItem ${
                            label?.count && 'hasValue'
                          } ${label?.type}`}
                        >
                          <span>{label?.count || '-'}</span>
                        </div>
                      ))}
                    </div>
                  </td>

                  <td
                    className="iconsColumnValues description pt8 pr8 pb8 pl8"
                    style={{
                      borderLeft: 'solid 1px #333541'
                    }}
                  >
                    <div
                      className="dFlex alignCenter justifyCenter"
                      style={{ gap: '8px' }}
                    >
                      <IconButton
                        onClick={() => {
                          if (!product?.canPrintLabel) return;

                          setModalSettings(
                            modalSettings.map((modal) =>
                              modal.name === 'labelPrintConfigDialog'
                                ? { ...modal, open: true, product }
                                : modal
                            )
                          );
                        }}
                        style={{ padding: 0, outline: 0 }}
                      >
                        <img
                          src={
                            !product?.canPrintLabel
                              ? PrintLabelProductDisabledIcon
                              : PrintLabelProductOutlineIcon
                          }
                          alt="PrintLabelProductIcon"
                        />
                      </IconButton>

                      <IconButton
                        aria-label="delete"
                        onClick={() => {
                          setModalSettings(
                            modalSettings.map((modal) =>
                              modal.name === 'stockExtractDialog'
                                ? {
                                    ...modal,
                                    initialProduct: product || null,
                                    open: true
                                  }
                                : modal
                            )
                          );
                        }}
                        style={{ padding: 0, outline: 0 }}
                      >
                        <img src={ExtractOutlineIcon} alt="ExtractIcon" />
                      </IconButton>

                      {labelManagerHasAllPermissions && (
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            setModalSettings(
                              modalSettings.map((modal) =>
                                modal.name === 'confirmDialog'
                                  ? {
                                      ...modal,
                                      open: true,
                                      product,
                                      title: `Deseja realmente excluir ${product?.description}?`,
                                      content:
                                        'Esta ação não pode ser desfeita. Deseja continuar?',
                                      onConfirm: () => handleDelete(product),
                                      onClose: () =>
                                        setModalSettings(
                                          modalSettings.map((modal) =>
                                            modal.name === 'confirmDialog'
                                              ? {
                                                  ...modal,
                                                  open: false,
                                                  product: null,
                                                  title: '',
                                                  content: '',
                                                  onConfirm: '',
                                                  onClose: ''
                                                }
                                              : modal
                                          )
                                        )
                                    }
                                  : modal
                              )
                            );
                          }}
                          style={{ padding: 0, outline: 0 }}
                        >
                          <img
                            className="deleteProductIcon"
                            src={DeleteProductOutlineIcon}
                            alt="DeleteProductIcon"
                          />
                        </IconButton>
                      )}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td colSpan={8} className="m10 textAlignCenter">
                    <hr style={{ marginTop: '-1px' }} />
                  </td>
                </tr>
              </>
            );
          })
        ) : (
          <tr>
            <th colSpan={8} className="m10 textAlignCenter">
              Não há nenhum produto.
            </th>
          </tr>
        )}
      </tbody>
    </ProductTable>
  );
}

export default DesktopProductsTable;
